const actions = {
  resetPlayerGameSessionState: 'RESET_PLAYER_GAME_SESSION_STATE',
  createPlayerGameSession: 'CREATE_PLAYER_GAME_SESSION',
  updatePlayerGameSession: 'UPDATE_PLAYER_GAME_SESSION',
  listPlayerGameSessions: 'LIST_PLAYER_GAME_SESSION',
  getPlayerGameSession: 'GET_PLAYER_GAME_SESSION',

  addSessionsToList: 'ADD_PLAYER_GAME_SESSIONS_TO_LIST',
  addPlayerGameSessionResultsToList: 'ADD_PLAYER_GAME_SESSION_RESULTS_TO_LIST',
  getPlayerGameSessions: 'GET_PLAYER_GAME_SESSIONS',
  resetPlayerGameSessionViewState: 'RESET_PLAYER_GAME_SESSION_VIEW_STATE',
};

export default actions;
